import React from 'react';
import { Tab, Tabs, TabPanel, TabPanels, TabList, PopoverBody } from '@chakra-ui/react';
import PropsEditorBody from './PropsEditorBody';
import CssEditorBody from '../SelectableCssVariables/CssEditorBody';

const EditorInputsBodyWM = () => {
	return (
		<PopoverBody px={0}>
			<Tabs size={'sm'} w={'100%'}>
				<TabList>
					<Tab>Props</Tab>
					<Tab>Variáveis</Tab>
				</TabList>
				<TabPanels maxH={'500px'}>
					<TabPanel p={1}>
						<PropsEditorBody />
					</TabPanel>
					<TabPanel p={1}>
						<CssEditorBody />
					</TabPanel>
				</TabPanels>
			</Tabs>
		</PopoverBody>
	);
};

const EditorInputsBody = React.memo(EditorInputsBodyWM);
export default EditorInputsBody;
